import * as yup from 'yup';

export const formSchema = yup.object({
    Name: yup.string().min(2).max(25).required('Business Name Required!'),
    Email: yup.string().min(2).max(25).email().required('Email Required!'),
});